import { render } from "./PopupForm.vue?vue&type=template&id=25e69716"
import script from "./PopupForm.vue?vue&type=script&lang=js"
export * from "./PopupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__